module.exports = __webpack_public_path__ + "img/1443974818.6cdc514e.jpg";